<template>

    <div v-if="dataLoaded && componentLoaded">

        <button
            class="btn btn-box-tool"
            v-tooltip="label"
            @click="openSelector"
        >
            <i class="mdi mdi-plus"></i>
            <span class="sr-only" v-text="label"></span>
        </button>

        <company-selector
            v-if="target === 'company'"
            ref="company"
            :on-selected="onSelected"
        ></company-selector>
        <contact-selector
            v-if="target === 'contact'"
            ref="contact"
            :on-selected="onSelected"
        ></contact-selector>
        <document-selector
            v-if="target === 'document'"
            ref="document"
            :on-selected="onSelected"
        ></document-selector>
        <project-selector
            v-if="target === 'project'"
            ref="project"
            :on-selected="onSelected"
        ></project-selector>

    </div>

</template>

<script>

import { mapGetters, mapActions } from 'vuex';
import axios from 'axios';
import CompanySelector from "./Selectors/CompanySelector";
import ContactSelector from "./Selectors/ContactSelector";
import DocumentSelector from "./Selectors/DocumentSelector";
import ProjectSelector from "./Selectors/ProjectSelector";

export default {

    components:{
        CompanySelector,
        ContactSelector,
        DocumentSelector,
        ProjectSelector,
    },

    computed: {
        ...mapGetters([
            'dataLoaded',
        ])
    },

    data() {
        return {
            allowedElements:[
                "contact",
                "crmgroup",
                "company",
                "document",
                "project",
            ],
            componentLoaded:false,
        }
    },

    methods: {
        ...mapActions([
            "parseData",
        ]),

        closeSelector() {
            this.$refs[this.target].closeSelector();
        },

        onSelected(element){
            axios.post(this.attachUrl, {
                uuid:element.uuid,
                target:this.target,
            })
            .then(() => {
                if (this.eventOnCompleted !== '') {
                    this.$emit(this.eventOnCompleted);
                }
            })
            .catch(() => {
                if (this.eventOnFailed !== '') {
                    this.$emit(this.eventOnFailed);
                }
            });
        },

        openSelector() {
            this.$refs[this.target].openSelector();
        },

        preFlight() {
            return this.allowedElements.indexOf(this.orig) !== -1 &&
                this.allowedElements.indexOf(this.target) !== -1 &&
                this.orig !== this.target &&
                this.origId !== "";
        },
    },

    mounted() {
        if (true === this.preFlight()) {
            this.parseData();
            this.componentLoaded = true;
        }
    },

    name:"CrmConnections",

    props: {
        eventOnCompleted:{
            type:String,
            default:'',
        },
        eventOnFailed:{
            type:String,
            default:'',
        },
        label: {
            type:String,
            default:'Connectie toevoegen',
        },
        orig: { required:true },
        origId: { required:true },
        target: { required:true },
        attachUrl: { required:true },
    }
}

</script>
